import { useVideoStatusWatcher } from '@/hooks/useVideoStatusWatcher';

/**
 * Componente sem UI — apenas monta o hook de monitoramento de status de vídeos.
 * Deve ser renderizado uma única vez no App.tsx, dentro do QueryClientProvider,
 * para evitar violação de regras de hooks em componentes com early returns.
 */
export function VideoStatusWatcher() {
  useVideoStatusWatcher();
  return null;
}
